import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { OverlaySetData } from '@/ts/interfaces/OverlaysInterfaces';

@Module({name: 'Overlays', namespaced: true})
export default class Overlays extends VuexModule {
    public accountSwitcherVisibility: boolean = false;

    @Mutation
    public RESET_OVERLAYS_STORE_STATE() {
        this.accountSwitcherVisibility = false;
    }

    get getAccountSwitcherVisibility(): boolean {
        return this.accountSwitcherVisibility;
    }

    @Mutation
    public SET_OVERLAY_VISIBILITY(data: OverlaySetData) {
        // @ts-ignore
        this[data.overlay] = data.visibility;
    }
}
